import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type AddProductRateMutationVariables = Types.Exact<{
  input: Types.AddProductRateCommand;
}>;


export type AddProductRateMutation = { __typename?: 'MutationModel', products: { __typename?: 'ProductMutationModel', addProductRate: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', message: string, argumentName?: string | null }> } } };


export const AddProductRateDocument = gql`
    mutation AddProductRate($input: AddProductRateCommand!) {
  products {
    addProductRate(input: $input) {
      errors {
        message
        argumentName
      }
    }
  }
}
    `;
export type AddProductRateMutationFn = Apollo.MutationFunction<AddProductRateMutation, AddProductRateMutationVariables>;

/**
 * __useAddProductRateMutation__
 *
 * To run a mutation, you first call `useAddProductRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductRateMutation, { data, loading, error }] = useAddProductRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductRateMutation(baseOptions?: Apollo.MutationHookOptions<AddProductRateMutation, AddProductRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductRateMutation, AddProductRateMutationVariables>(AddProductRateDocument, options);
      }
export type AddProductRateMutationHookResult = ReturnType<typeof useAddProductRateMutation>;
export type AddProductRateMutationResult = Apollo.MutationResult<AddProductRateMutation>;
export type AddProductRateMutationOptions = Apollo.BaseMutationOptions<AddProductRateMutation, AddProductRateMutationVariables>;